import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

export const Container = styled.button.attrs({
  type: props => props.type || 'button',
})`
  border: none;
  outline: none;
  background: none transparent;
  padding: 0;
  line-height: 1.5;
  font-weight: normal;
  cursor: pointer;
  ${props =>
    props.full &&
    css`
      width: 100%;
    `};
  &:disabled {
    cursor: not-allowed;
  }
`;

export default class ButtonBase extends PureComponent {
  static propTypes = {
    full: PropTypes.bool,
  };

  static defaultProps = {
    full: false,
  };

  render() {
    const { children, ...props } = this.props;

    return <Container {...props}>{children}</Container>;
  }
}



// WEBPACK FOOTER //
// ../pos-master/packages/pos-components/src/ButtonBase/ButtonBase.jsx